export { default as GDMListItemText } from './GDMListItemText';

export type { GDMListItemTextComponent, GDMListItemTextProps } from './GDMListItemText.type';
